import React, { useMemo } from 'react';


import { Stack } from 'ui/stack';

import { Switch } from 'ui/switch';
import TableComponent from 'components/partials/table-component/table-component';

import { getOverviewTableSettings } from './overview-table-settings';

import type { OverviewRow } from '../results-step.types';

interface OverviewTabProps {
  rows: OverviewRow[];
  showModeledActualYear: boolean;
  onShowModeledActualYearChange: (value: boolean) => void;
}

const OverviewTab = ({
  rows,
  showModeledActualYear,
  onShowModeledActualYearChange,
}: OverviewTabProps): React.JSX.Element => {
  const columns = useMemo(
    () => getOverviewTableSettings({ showModeledActualYear }),
    [showModeledActualYear]
  );

  return (
    <Stack data-testid="results-overview-tab" sx={{ gap: 1.5 }}>
      <h3 className="text-lg font-bold text-gray-700">
        Modeled aid applicants/comparison
      </h3>

      <Stack sx={{ gap: 1, overflow: 'hidden', mx: -0.25, px: 0.25 }}>
        <Switch
          size="small"
          label="Modeled current year results"
          checked={showModeledActualYear}
          onChange={(_event, checked) => onShowModeledActualYearChange(checked)}
          data-testid="results-modeled-actual-toggle"
        />

        <TableComponent
          columns={columns}
          data={rows}
          isLoading={false}
          pagination={false}
        />
      </Stack>
    </Stack>
  );
};

export default OverviewTab;
